import {Collapse} from "@bezlimit/bezlimit-ui";
import {DownOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";

export const LotteryRules = ({description}: IProps): JSX.Element => {
    const {t} = useTranslation();
    const {Panel} = Collapse;
    const createMarkup = (description: string) => {
        return {__html: description};
    };

    return (
        <Collapse
            ghost
            className="lottery-collapse"
            expandIconPosition="end"
            expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
        >
            <Panel header={t("Подробные условия проведения")} key="1">
                <div className="rules-description">
                    <div
                        dangerouslySetInnerHTML={createMarkup(description)}
                    ></div>
                </div>
            </Panel>
        </Collapse>
    );
}

interface IProps {
    description: string;
}